import _isEmpty from "lodash/isEmpty";

function generateCircleColors(status) {
  const primaryColor = document.querySelector(":root").style.getPropertyValue("--study-primary-color");
  let setColor = "";
  switch (status) {
    case "all":
      setColor = "#5d5d5d";
      break;
    case "ACTIVE":
      setColor = primaryColor;
      break;
    case "DISQUALIFIED":
      setColor = "#fb9a99";
      break;
    case "ACTIVEWMODIFICATION":
      setColor = "#b269d4";
      break;
    case "WITHDRAWSTUDY":
      setColor = "#fdbf6f";
      break;
    case "DISCONTINUED":
      setColor = "#fb9a99";
      break;
    default:
      setColor = "#eaeaea";
      break;
  }
  return setColor;
}

function circleIsEmpty(circles) {
  if (_isEmpty(circles)) {
    return true;
  } else {
    const status = [];
    for (const circle in circles) {
      if (!_isEmpty(circles[circle])) {
        status.push(true);
      }
    }
    return _isEmpty(status);
  }
}

function generateCircleStrokeColors(status) {
  const primaryColor = document.querySelector(":root").style.getPropertyValue("--study-primary-color");
  let setStrokeColor = "";
  switch (status) {
    case "all":
      setStrokeColor = "#5d5d5d";
      break;
    case "ACTIVE":
      setStrokeColor = primaryColor;
      break;
    case "DISQUALIFIED":
      setStrokeColor = "#fb9a99";
      break;
    case "ACTIVEWMODIFICATION":
      setStrokeColor = "#b269d4";
      break;
    case "WITHDRAWSTUDY":
      setStrokeColor = "#fdbf6f";
      break;
    case "DISCONTINUED":
      setStrokeColor = "#fb9a99";
      break;
    default:
      setStrokeColor = "#5d5d5d";
      break;
  }
  return setStrokeColor;
}

function sum(numInArray) {
  if (!numInArray || !Array.isArray(numInArray)) {
    return;
  }
  return numInArray.length === 0 ? 0 : numInArray[0] + sum(numInArray.slice(1));
}

export { sum, generateCircleColors, generateCircleStrokeColors, circleIsEmpty };
